import React from "react";

const Loader = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <img
        src="/logo192.png" // Cambia esto a la ruta de tu imagen
        alt="Cargando..."
        className="w-64 h-64 animate-spin"
      />
    </div>
  );
};

export default Loader;
